
import { IMyDpOptions } from "mydatepicker";
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { GlobalComponent } from 'src/app/global/global.component';
import { FilterSettingsModel, IFilter, GridComponent, DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { ToolbarItems } from '@syncfusion/ej2-grids';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/service/general.service';
import { Observable } from 'rxjs/Observable';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  AddTypeBO, GetListBasetype, WhereCondition,
  AddNoteBO, GetListBasenote, WhereConditionnote
} from './employee-notes.model';
import { EmployeeNotesService } from './employee-notes.service';
import { EmployeeNotesDateService } from './employee-nottes.service';
import { EmployeeNotesTypeService } from './employee-notesType-service';
import { HttpErrorResponse } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { DateService } from "src/app/date.service";
import { EmployeeBO, functionpermission } from "../employee.model";

@Component({
  selector: 'app-employee-notes',
  templateUrl: './employee-notes.component.html',
  styleUrls: ['./employee-notes.component.scss']
})
export class EmployeeNotesComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild("pdfNotesList") pdfNotesList;
  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('gridnotes') public gridnotes: GridComponent;

  EmployeeList: any = new EmployeeBO();
  addtypeBO: AddTypeBO = new AddTypeBO();
  addnoteBO: AddNoteBO = new AddNoteBO();
  @Input() Employee: EmployeeBO = new EmployeeBO();
  conditionData: WhereCondition = new WhereCondition();
  conditionDatanote: WhereConditionnote = new WhereCondition();
  getemployee: GetListBasetype = new GetListBasetype();
  getemployeenotes: GetListBasenote = new GetListBasenote();

  today = new Date();

  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    showClearDateBtn: false,
    editableDateField: true,
  };
  public myDatePickerOptionsDOB: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    disableSince: {
      year: this.today.getFullYear(),
      month: this.today.getMonth() + 1,
      day: this.today.getDate() + 1,
    },
    showClearDateBtn: false,
    editableDateField: true,
  };

  // ,................................................................................................................................................................
  initialPage: object;
  filterOptions: FilterSettingsModel;
  filter: IFilter;

  public filterSettings: object;
  public formatOptions: object
  public toolbar: ToolbarItems[];
  conditionlist: WhereCondition[] = [];
  noteLst: AddNoteBO[] = [];
  arraycol: any = [];
  conditionlistnote: WhereConditionnote[] = [];
  StatusList: any = [];
  statusListAll: any = [];
  typedropdown: any = [];

  FromDateFilter: any
  EndDateFilter: any
  type: string = "";
  ContactId: any;
  typenotes: string = "";
  noteId: any;
  employeename_print: any
  employeeBOB_print: any

  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];

  public data: Observable<DataStateChangeEventArgs>;
  public datanotes: Observable<DataStateChangeEventArgs>;
  // .................................................................................................................................................

  constructor(public notesservice: EmployeeNotesService, public global: GlobalComponent, public generalservice: GeneralService,
    public toasterservice: ToastrService, public employeenotesdateservice: EmployeeNotesDateService, public datepipe: DatePipe,
    public ngxservice: NgxUiLoaderService,
    public dateservice: DateService,
    public employeeNotesTypeService: EmployeeNotesTypeService) {

    this.datanotes = employeenotesdateservice;

    this.data = employeenotesdateservice;
  }
  fp: functionpermission = new functionpermission()
  // .......................................................NG ONIT.................................................................................
  ngOnInit(): void {
    this.filterOptions = { type: 'Excel' };
    this.filterSettings = { type: 'Menu' };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };

    this.getType();
    this.getStatus();
    this.getStatusAll();
    this.getnotesgrid();
    this.getpermission();
  }

  getpermission() {
    let params = new URLSearchParams();
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != ''))
      params.append("pagecode", "employee");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.notesservice.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data != null) {
        this.fp = data;
      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
  // ............................................................................................................................................
  //.......................................DateFormat.................................................
  DateFormat(event, type, name) {
    if (type == "inputchanged") {
      if (name == 'FilterFromDate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.FromDateFilter = element;
        }
      }
      if (name == 'FilterToDate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.EndDateFilter = element;
        }
      }
    }
    if (type == "datechanged") {
      if (name == 'FilterFromDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.FromDateFilter = element;

        }
      }
      if (name == 'FilterToDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.EndDateFilter = element;
        }
      }

    }
  }




  //...............................................ApplyFilter....................................................
  ApplyFilter() {

    if ((this.FromDateFilter != null && this.FromDateFilter != undefined && this.FromDateFilter != '')
      && (this.EndDateFilter != null && this.EndDateFilter != undefined && this.EndDateFilter != '')) {

      if (new Date(this.FromDateFilter).getTime() > new Date(this.EndDateFilter).getTime()) {
        this.toasterservice.error("End date should greater than start date");
        return;
      }

      this.getemployeenotes.startDate = this.global.getDateTimeString(this.FromDateFilter)
      this.getemployeenotes.endDate = this.global.getDateTimeString(this.EndDateFilter)
    }

    this.getnotesgrid();
  }

  RefreshFilter() {
    this.getemployeenotes.field = this.getemployeenotes.orderColumn = "notes";
    this.getemployeenotes.matchCase = false;
    this.getemployeenotes.operator = "startswith";
    this.getemployeenotes.value = "";
    this.getemployeenotes.type= "string";
    this.getemployeenotes.orderType = "asc";
    this.EndDateFilter = null;
    this.FromDateFilter = null;
    this.getemployeenotes.startDate = null;
    this.getemployeenotes.endDate = null;
    this.getemployeenotes.noteTypeId = "00000000-0000-0000-0000-000000000000"
    this.getnotesgrid();
  }


  // =======================Grid Column selector ================ //
  show() {
    this.grid.columnChooserModule.openColumnChooser(500, 50);
  }

  showColumn() {
    this.gridnotes.columnChooserModule.openColumnChooser(500, 50);
  }


  getStatus() {
    let params = new URLSearchParams();
    params.append("ListCode", "STATUS");
    this.notesservice.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.StatusList = data;
      this.addtypeBO.statusLid = this.StatusList.filter(st => st.lovCode == "ACTIVE")[0].id;
    })
  }

  getStatusAll() {
    let params = new URLSearchParams();
    params.append("listCode", "STATUS");
    this.notesservice.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.statusListAll = data;
      this.getemployee.statusLid = this.statusListAll?.filter(s => s.lovCode.trim().toUpperCase() == "ACTIVE")[0].id;
      this.statusListAll.push({ id: '00000000-0000-0000-0000-000000000000', lovName: "All" }); 
      this.gettypegrid();
    })
  }



  ModelType: any;
  TypeCreateupdate(data) {
    this.ModelType = data;
    if (this.ModelType == 'new') {
      this.addtypeBO = new AddTypeBO();
    }
    else {
      this.ModelType = 'edit';
    }

  }

  // ........................................................saveupdate type........................................................//

  saveupdatetype(type: string) {
    if (this.addtypeBO.id == '00000000-0000-0000-0000-000000000000') {
      var saveList: AddTypeBO = JSON.parse(JSON.stringify(this.addtypeBO));
      this.notesservice.saveupdatetype(saveList).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.toasterservice.success("saved  Successfully", "type saved");
        document.getElementById("openaddtypemodal").click();

        this.gettypegrid();
      },
        err => {
          this.toasterservice.error(err.error);

        });
    }
    else {

      this.notesservice.saveupdatetype(this.addtypeBO).subscribe((data: any) => {
        this.toasterservice.success("update  Successfully", "type Updated ");
        document.getElementById("openaddtypemodal").click();

        this.gettypegrid();
      },
        err => {
          this.toasterservice.error(err.error);

        });
    }


  }
  // .....................................................typegrid............................................................

  gettypegrid() {
    this.data = this.employeeNotesTypeService;
    this.employeeNotesTypeService.execute(this.getemployee);
    let count = 0;
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;
    })
  }
  // .......................................................type datachangevent.........................................................
  public onActionComplete(args) {
    this.getemployee.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.getemployee.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }

  }

  // ....................................................................................................................................................

  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.getemployee.orderColumn = state.sorted[0].typeName;
        this.getemployee.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.getemployee.field = state.action.currentFilterObject.field;
      this.getemployee.matchCase = state.action.currentFilterObject.matchCase;
      this.getemployee.operator = state.action.currentFilterObject.operator;
      this.getemployee.value = state.action.currentFilterObject.value;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.getemployee.field = "typeName";
        this.getemployee.matchCase = false;
        this.getemployee.operator = "contains";
        this.getemployee.value = "";
        this.getemployee.type = "string";
      }
    }
    this.gettypegrid();
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].supportplanner.Pagesize != state.take) {
          this.arraycol[0].supportplanner.Pagesize = state.take
        }

      }
    }
  }

  edittype(data) {
    this.addtypeBO = JSON.parse(JSON.stringify(data));
    this.ModelType ='edit';
  }
  // ..........................................................Delete type..........................................
  setDeleteId(value) {
    this.ContactId = value;
  }


  Delete() {
    let param = new URLSearchParams()
    param.append("Id", this.ContactId)
    this.notesservice.delete(param).subscribe((_data: any) => {
      this.toasterservice.success("Type has been deleted successfully", "Type deleted");
      document.getElementById("openModal2").click();
      this.gettypegrid();

    },
      err => {
        this.toasterservice.error(err.error);
      })

  }


  //..... ..............................................save update notes................................................................................

  opennewnote() {
    this.addnoteBO = new AddNoteBO();
    this.addnoteBO.id = "00000000-0000-0000-0000-000000000000";
    this.addnoteBO.date = this.datepipe.transform(new Date(), "yyyy-MM-dd'T'HH:mm")
    this.addnoteBO.user = this.global.logginedUserName

    this.addnoteBO.notes = ""
    this.getType();
  }

  // .....................................................editnotes......................................................................................
  editNote(data) {
    this.addnoteBO.noteTypeId = data.noteTypeId
    this.addnoteBO.id = data.id
    this.addnoteBO.date = this.datepipe.transform(data.date, "yyyy-MM-dd'T'HH:mm")
    this.addnoteBO.user = this.global.logginedUserName
    this.addnoteBO.notes = data.notes
  }


  saveNote() {
    this.addnoteBO.employeeId = this.Employee.id
    if (this.addnoteBO.id == '00000000-0000-0000-0000-000000000000') {
      this.notesservice.saveupdatenote(this.addnoteBO).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.toasterservice.success(
          "Notes  Saved successfully",
          "Notes  Saved",
        );

      });
    }
    else {
      this.notesservice.updatenote(this.addnoteBO).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.toasterservice.success(
          "Notes  Updated successfully",
          "Notes  Updated",
        );

      });
    }
    setTimeout(() => {
      this.getnotesgrid();
    }, 1000);

    document.getElementById("Addnotes").click()

  }

  // ....................................Type DROPDOWN..................................................
  getType() {
    this.notesservice.TypeDropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.typedropdown = data;

    })
  }

  // ........................................................notes actioncomplete...................................................

  public onActionCompletenotes(args) {
    this.getemployeenotes.currentpageno = this.gridnotes.pagerModule.pagerObj.currentPage;
    this.getemployeenotes.pageitem = this.gridnotes.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }

    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.getemployeenotes.type = args.columnType;
    }
  }

  // ....................................................................................................................................

  public dataStateChangenotes(state): void {
    console.log(state,"state")
    this.typenotes = (state.action.requestType).toString();
    console.log("typenotes", this.typenotes)
    if (this.typenotes != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.getemployeenotes.orderColumn = state.sorted[0].name;
        this.getemployeenotes.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.typenotes == "filtering" && state.action.action != "clearFilter") {
      console.log("if")
      this.getemployeenotes.field = state.action.currentFilterObject.field;
      this.getemployeenotes.matchCase = state.action.currentFilterObject.matchCase;
      this.getemployeenotes.operator = state.action.currentFilterObject.operator;
      this.getemployeenotes.value = state.action.currentFilterObject.value;
      // if(this.getemployeenotes.field == "date"){
      //   this.getemployeenotes.type = "datetime";
      //    this.getemployeenotes.operator = "equal";
      // }
      if(this.getemployeenotes.type == 'number'){
        this.getemployeenotes.value = (this.getemployeenotes.value != null && this.getemployeenotes.value != undefined)
        ? this.getemployeenotes.value.toString() : null;
      }
      if(this.getemployeenotes.type == "date" || this.getemployeenotes.type == "datetime"){
        this.getemployeenotes.value = (this.getemployeenotes.value!= null && this.getemployeenotes.value != "" && this.getemployeenotes.value != undefined)
        ? this.global.getDateTimeString(this.getemployeenotes.value)
        : this.getemployeenotes.value;
      }
      //if(this.getemployeenotes.field)
    }
    if ((this.typenotes == "filtering" && state.action.action == "clearFilter")
       || (this.getemployeenotes.type != 'string' && (this.getemployeenotes.value == null || this.getemployeenotes.value == undefined || this.getemployeenotes.value == ''))) {
      this.getemployeenotes.field = "notes";
      this.getemployeenotes.matchCase = false;
      this.getemployeenotes.operator = "startswith";
      this.getemployeenotes.value = "";
      this.getemployeenotes.type= "string";
    }
    this.getnotesgrid();
    if (this.typenotes == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].supportplanner.Pagesize != state.take) {
          this.arraycol[0].supportplanner.Pagesize = state.take
        }

      }
    }
  }
  // .....................................................notesgrid............................................................
  getnotesgrid() {
    this.getemployeenotes.employeeId = this.Employee.id
    this.employeenotesdateservice.executes(this.getemployeenotes);
    let count = 0;
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.noteLst = data.result;

      count = count + 1;
    })
  }
  // ..............................................................delete notes...............................................................

  noteDeleteId(value) {
    this.noteId = value;
  }


  NoteDelete() {
    let param = new URLSearchParams()
    param.append("Id", this.noteId)
    this.notesservice.deletenote(param).subscribe((_data: any) => {
      this.toasterservice.success("Notes has been deleted successfully", "Notes  deleted");
      document.getElementById("openModalnotes").click();
      this.getnotesgrid();

    },
      err => {
        this.toasterservice.error(err.error);
      })

  }


  // ...........................................print...........................................................................

  printData() {
    this.ngxservice.start();
    (this.pdfNotesList.A4 = true),
      (this.pdfNotesList.portrait = true),
      (this.pdfNotesList.keepTogether = ".prevent-split"),
      (this.pdfNotesList.scale = 0.8),
      (this.pdfNotesList.height = 100),
      this.pdfNotesList.margin = { left: "1.2cm", top: "1cm", right: "0.2cm", bottom: "1cm", }
    this.pdfNotesList.padding = { bottom: "50px" };


    this.pdfNotesList.saveAs(
      "Employee-NotesReport" +
      new Date().toLocaleDateString() +
      "-" +
      new Date().toLocaleTimeString()
    );
    this.ngxservice.stop();
  }

}
